import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'sputnik-ui'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import CircularProgress from '@material-ui/core/CircularProgress'
import TextField from '@material-ui/core/TextField'
import Zoom from '@material-ui/core/Zoom'

import Api from 'utils/api'
import { moveHouse } from 'store/operations'

function Transition(props) {
  return <Zoom direction="up" {...props} />
}

function TransferHouseModal({ open, handleClose, house, dispatch }) {
  const [streets, setStreets] = React.useState(null)
  const [selectedStreet, setSelectedStreet] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const [search, setSearch] = React.useState('')

  const localityUuid = React.useMemo(() => {
    if (!house || !house.parents) return null
    const locality = house.parents.find((p) => p.type === 'locality')
    return locality ? locality.uuid : null
  }, [house])

  React.useEffect(() => {
    if (open && localityUuid) {
      setStreets(null)
      Api.request(`/streets?parent_uuid=${localityUuid}`)
        .then((data) => setStreets(data))
        .catch(() => setStreets([]))
    }
    if (!open) {
      setSelectedStreet(null)
      setSearch('')
    }
  }, [open, localityUuid])

  const filteredStreets = React.useMemo(
    () =>
      streets
        ? streets.filter((s) =>
            s.full_name.toLowerCase().includes(search.toLowerCase())
          )
        : [],
    [streets, search]
  )

  const handleConfirm = () => {
    if (!selectedStreet) return
    setLoading(true)
    dispatch(moveHouse(house.uuid, selectedStreet.uuid))
      .then(handleClose)
      .catch(() => setLoading(false))
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      PaperProps={{ style: { minWidth: 400 } }}
    >
      <DialogTitle>Перенести дом</DialogTitle>
      <DialogContent>
        <TextField
          placeholder="Поиск улицы..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
          style={{ marginBottom: 8 }}
        />
        {!streets ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}>
            <CircularProgress />
          </div>
        ) : (
          <List dense style={{ maxHeight: 360, overflowY: 'auto' }}>
            {filteredStreets.map((s) => (
              <ListItem
                key={s.uuid}
                button
                selected={selectedStreet && selectedStreet.uuid === s.uuid}
                onClick={() => setSelectedStreet(s)}
              >
                <ListItemText primary={s.full_name} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} rounded secondary disabled={loading}>
          Отмена
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={loading || !selectedStreet}
          rounded
          primary
        >
          Перенести
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = ({ resources }) => ({
  house: resources.current,
})

export default connect(mapStateToProps)(TransferHouseModal)
